// extracted by mini-css-extract-plugin
export default {"footer":"MainFooter_footer__EcruN","footerAnchor":"MainFooter_footerAnchor__0zTCI"};